type Props = {
    className?: string;
};

export default function LoaderIcon({ className = "h-14 w-14" }: Props) {
    return (
        <div
            className={`${className} animate-spin`}
            style={{
                maskImage: 'conic-gradient(from 90deg, white 0deg, transparent 270deg)',
                WebkitMaskImage: 'conic-gradient(from 90deg, white 0deg, transparent 270deg)',
                willChange: 'transform',
            }}
        >
            <svg viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="29" cy="29" r="26" stroke="white" strokeWidth="4" fill="none" />
            </svg>
        </div>
    );
}